import React, { useEffect, useRef, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import Barcode from "react-barcode";
//Redux
import { useDispatch, useSelector } from "react-redux"; //useDispatch

//Serivce

//Components
import Layout from "../../../Layout/Layout";
import CustomerConstants from "../../../common/CustomerConstants";
import CatalogEditMaterialModal from "../../../Components/Modal/supplier_app/MaterialCatalogModal/CatalogEditMaterialModal";
import CatalogAddMaterialModal from "../../../Components/Modal/supplier_app/MaterialCatalogModal/CatalogAddMaterialModal";
import CatalogMaterialDetailModal from "../../../Components/Modal/supplier_app/MaterialCatalogModal/CatalogMaterialDetailModal";
import {
  catalogNr,
  getCatalogList,
} from "../../../redux/feature/supplier_app/purchasingSlice";
import { useReactToPrint } from "react-to-print";
import { Button, Modal } from "react-bootstrap";
import { Form } from "react-bootstrap";
import QRCode from "react-qr-code";
const MaterialCatalog = () => {
  localStorage.setItem("menu", "Catalog Manage");
  localStorage.setItem("submenu", "Catalog Manager");

  const dispatch = useDispatch();

  let purchaseOrderTable = useSelector(
    (state) => state?.purchasing?.catalogData?.pagination,
  );

  let catalogData = useSelector((state) => state?.purchasing?.catalogData);

  const [data, setData] = useState();

  const [getNewPerPage, setNewPerPage] = useState(10);

  const [isCardVisible2, setCardVisible2] = useState(true);
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };

  useEffect(() => {
    let obj = {
      queryName: "GET_Catalog_List",
      module: "",
      page: 1,
      per_page: 10,
    };
    dispatch(getCatalogList(obj));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
       queryName: "GET_Catalog_List",
      page: page,
      per_page: newPerPage,
    };
    setNewPerPage(newPerPage);
    dispatch(getCatalogList(obj));
    setData(catalogData?.data);
  };

  const handlePageChange = (page) => {
    let obj = {
      queryName: "GET_Catalog_List",
      page: page,
      per_page: getNewPerPage,
    };

    dispatch(getCatalogList(obj));
    setData(catalogData?.data);
  };

  const refreshCatalogList = () => {
    dispatch(
      getCatalogList({
        queryName: "GET_Catalog_List",
        module: "",
        page: 1,
        per_page: 10,
      }),
    );
  };

  useEffect(() => {
    refreshCatalogList();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setData(catalogData?.data || []);
  }, [catalogData]);

  const [modalShowEditProduct, setModalShowEditProduct] = useState(false);
  const [modalShowAddProduct, setModalShowAddProduct] = useState(false);
  const [modalShowDetailProduct, setModalShowDetailProduct] = useState(false);

  const barcodeRef = useRef();
  const qrCodeRef = useRef();

  const PrintableQrcode = React.forwardRef(({ data, quantity }, ref) => {
    if (!data) return null;

    const items = Array.from({ length: quantity > 0 ? quantity : 1 });

    const qrValue = `
      Code: ${data.materialCode}
      MRP: ${data.mrPrice} INR
      Barcode ID: ${data.barcode}
    `;

    return (
      <div ref={ref} style={{ padding: "20px", width: "100%" }}>
        {/* Container flex-wrap tho unte items automatic ga kindaki vasthayi */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "flex-start",
            gap: "15px",
          }}
        >
          {items.map((_, index) => (
            <div
              key={index}
              style={{
                width: "30%", // 3 items per row ravali ante 30-32% ivvali
                border: "1px dashed #ccc", // Cutting ki easy ga border
                padding: "15px",
                marginBottom: "15px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                pageBreakInside: "avoid", // Item sagam lo cut avvakunda chusukuntundi
              }}
            >
              <div style={{ textAlign: "center" }}>
                <QRCode value={qrValue} size={120} />{" "}
                {/* Size konchem taggincha fit avvadaniki */}
                <div style={{ marginTop: "10px", fontSize: "12px" }}>
                  <p className="m-0">
                    <strong>{data.materialCode}</strong>
                  </p>
                  <p className="m-0">{data.barcode}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  });

  const PrintableBarcode = React.forwardRef(({ data, quantity }, ref) => {
    if (!data) return null;

    const items = Array.from({ length: quantity > 0 ? quantity : 1 });

    return (
      <div ref={ref} style={{ padding: "20px", width: "100%" }}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "flex-start",
            gap: "15px",
          }}
        >
          {items.map((_, index) => (
            <div
              key={index}
              style={{
                width: "45%", // Row ki 2 Barcodes vasthayi (neat ga untundi)
                border: "1px dashed #ccc",
                padding: "15px",
                marginBottom: "15px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                pageBreakInside: "avoid",
              }}
            >
              <div style={{ textAlign: "center" }}>
                <Barcode
                  value={data.barcode || "N/A"}
                  width={1.5} // Bar width konchem taggincha
                  height={60}
                  format="CODE128"
                  displayValue={true}
                  fontSize={14}
                />
                <div style={{ marginTop: "5px", fontSize: "12px" }}>
                  <p className="m-0">
                    <strong>{data.materialCode}</strong>
                  </p>
                  <p className="m-0">MRP: {data.mrPrice}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  });

  // --- New States for Print Quantity ---
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [printQuantity, setPrintQuantity] = useState(1); // Default 1 copy
  const [printType, setPrintType] = useState(""); // "BARCODE" or "QR"
  const [printRowData, setPrintRowData] = useState(null); // Selected row data

  // React-to-print hooks
  const handlePrintBarcode = useReactToPrint({
    contentRef: barcodeRef,
    documentTitle: "Barcode_Print",
    onAfterPrint: () => setShowPrintModal(false), // Print ayyaka modal close
  });

  const handlePrintQr = useReactToPrint({
    contentRef: qrCodeRef,
    documentTitle: "QR_Print",
    onAfterPrint: () => setShowPrintModal(false),
  });

  const showEditProduct = (row) => {
    setModalShowEditProduct(true);
    dispatch(catalogNr(row.catalogNr));
  };
  const showAddProduct = () => {
    setModalShowAddProduct(true);
  };
  const showProductDetail = (row) => {
    setModalShowDetailProduct(true);
    dispatch(catalogNr(row.catalogNr));
  };
  const hideModal = () => {
    setModalShowEditProduct(false);
    setModalShowAddProduct(false);
    setModalShowDetailProduct(false);
  };
  const openPrintModal = (row, type) => {
    setPrintRowData(row);
    setPrintType(type); // 'BARCODE' or 'QR'
    setPrintQuantity(1); // Reset to 1 every time
    setShowPrintModal(true);
  };

  const handleFinalPrint = () => {
    if (printType === "BARCODE") {
      handlePrintBarcode();
    } else if (printType === "QR") {
      handlePrintQr();
    }
  };

  const columns = [
    {
      name: "Catalog Nr",
      selector: (row) => row.catalogNr,
      cell: (row) => (
        <button className="btnInfo" onClick={() => showProductDetail(row)}>
          {row.catalogNr}
        </button>
      ),
    },

    {
      name: "Barcode",
      cell: (row) => (
        <button
          className="btn btn-sm d-flex align-items-center gap-1"
          style={{ backgroundColor: "#98d8d8", fontWeight: "bold" }}
          // OLD: onClick={() => triggerPrint(row)}
          // NEW:
          onClick={() => openPrintModal(row, "BARCODE")}
          title="Print Barcode"
        >
          <i className="bi bi-upc-scan"></i>
          Print
        </button>
      ),
      width: "120px",
    },
    {
      name: "QR Code",
      cell: (row) => (
        <button
          className="btn btn-sm d-flex align-items-center gap-1"
          style={{ backgroundColor: "#98d8d8", fontWeight: "bold" }}
          // OLD: onClick={() => triggerPrintQrCode(row)}
          // NEW:
          onClick={() => openPrintModal(row, "QR")}
          title="Print QR Code"
        >
          <i className="bi bi-qr-code-scan"></i>
          Print QR
        </button>
      ),
      width: "130px",
    },

    {
      name: "Material Name",
      selector: (row) => row.productName || "--",
      cell: (row) => (
        <div
          className="d-flex justify-content-center align-items-center cursor-pointer"
          onClick={() => showProductDetail(row)}
        >
          <img
            src={row.imageUrl}
            alt="Profile"
            className="profileImageCss p-1"
            style={{ width: "60px" }}
          />
          <div className="ms-2">
            <p className="m-0 p-0 pt-1 fw-bold">{row.productName} </p>
            <p className="m-0 p-0 pt-1">{row.productNumber} </p>
          </div>
        </div>
      ),
      sortable: true,
      width: "400px",
    },
    {
      name: "Purchase Unit Price",
      selector: (row) => row.price || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.price} </p>
        </div>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Category",
      selector: (row) => row.category || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.category} </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Sub Category",
      selector: (row) => row.subCategory || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.subCategory} </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Description",
      selector: (row) => row.description || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.description} </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Vendor",
      selector: (row) => row.vendor || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.vendor} </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Vendor Location",
      selector: (row) => row.vendorLocation || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.vendorLocation} </p>
        </div>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Warranty",
      selector: (row) => row.warranty || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.warranty} </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Action",
      selector: (row) => row.purchaseType || "--",
      cell: (row) => (
        <div>
          <button
            className="btn d-flex align-items-center w-100"
            onClick={() => showEditProduct(row)}
          >
            <i class="bi bi-pencil-square pe-2"></i>{" "}
            <sapn className="m-0 p-0 pt-1">Edit </sapn>
          </button>
        </div>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Delete",
      selector: (row) => row.purchaseType || "--",
      cell: (row) => (
        <div>
          <button class="btn btn-danger">
            <i class="bi bi-trash3"></i>
          </button>
        </div>
      ),
      sortable: true,
      width: "200px",
    },
  ];

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Catalog </h2>
            <p className="subText">Catalog </p>
            <hr />
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-down"
                            : "bi-chevron-right"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">M</span>
                    </Col>
                    <Col xs={6} md={4} lg={4}>
                      <span className="headerTitle">Material</span>
                      <span className="subHeaderTitle">Material</span>
                    </Col>

                    <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                      <Col xs={3} md={3} lg={3} className="">
                        <button
                          className="btnTable d-flex justify-content-center"
                          onClick={showAddProduct}
                        >
                          <p className="m-0 me-2">Add Catalog Material</p>
                          <i class="bi bi-plus-square"></i>
                        </button>
                      </Col>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={data}
                          paginationRowsPerPageOptions={
                            CustomerConstants.ROW_PER_PAGE
                          }
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          pagination
                          paginationServer
                          paginationTotalRows={purchaseOrderTable.total}
                          selectableRows
                        />
                      </Col>
                    </Row>
                    <Modal
                      show={showPrintModal}
                      onHide={() => setShowPrintModal(false)}
                      centered
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>
                          Print {printType === "QR" ? "QR Code" : "Barcode"}
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Form.Group>
                          <Form.Label>Enter Quantity (Copies)</Form.Label>
                          <Form.Control
                            type="number"
                            min="1"
                            value={printQuantity}
                            onChange={(e) =>
                              setPrintQuantity(parseInt(e.target.value) || 1)
                            }
                            autoFocus
                          />
                        </Form.Group>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          onClick={() => setShowPrintModal(false)}
                        >
                          Close
                        </Button>
                        <Button variant="primary" onClick={handleFinalPrint}>
                          Print {printQuantity} Copies
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <CatalogEditMaterialModal
        show={modalShowEditProduct}
        onHide={() => hideModal()}
        // dropdownData={getAccountGroup}
        onSuccess={refreshCatalogList}
      />
      <CatalogAddMaterialModal
        show={modalShowAddProduct}
        onHide={() => hideModal()}
        // dropdownData={getAccountGroup}
        onSuccess={refreshCatalogList}
      />
      <CatalogMaterialDetailModal
        show={modalShowDetailProduct}
        onHide={() => hideModal()}
        onSuccess={refreshCatalogList}
      />
      <div style={{ display: "none" }}>
        <PrintableBarcode
          ref={barcodeRef}
          data={printRowData}
          quantity={printQuantity}
        />
        <PrintableQrcode
          ref={qrCodeRef}
          data={printRowData}
          quantity={printQuantity}
        />
      </div>
    </main>
  );
};

export default MaterialCatalog;
